import { SxProps, Theme } from "@mui/material/styles";

export const keyDetailsItemContainer: SxProps<Theme> = (theme) => ({
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(2),
});

export const keyDetailsItemLabel: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    fontFamily: "HsvSlab",
    marginBottom: theme.spacing(0.5),
});

export const keyDetailsItemValue: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.primary,
    fontFamily: "HsvSlab",
    fontWeight: "bold",
    fontSize: "1.5rem",
});

export const customDivider: SxProps<Theme> = (theme) => ({
    alignSelf: "center",
    marginTop: "16px",
    borderBottomWidth: "2px",
});
